import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { ContractSubObjectUpdateInput } from 'gql/graphql';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { uerUpdateContractSubObjectGql } from '../../workOrderQueries';

const requestId = 'uerUpdateContractSubObject';

export const useUerUpdateContractSubObject = (contractId?: number, onSuccess?: () => void) => {
    const dispatch = useDispatch();

    const [uerUpdateContractSubObjectReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        uerUpdateContractSubObjectReset(undefined);
        onSuccess?.();
    }, [onSuccess, uerUpdateContractSubObjectReset]);

    const [
        uerUpdateContractSubObjectData,
        uerUpdateContractSubObjectStatus,
        uerUpdateContractSubObjectError,
        uerUpdateContractSubObjectRequest,
    ] = useRequest({
        requestId,
        query: uerUpdateContractSubObjectGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const uerUpdateContractSubObjectMakeRequest = useCallback(
        (input: ContractSubObjectUpdateInput) => {
            dispatch(uerUpdateContractSubObjectRequest({ input, contractId }));
        },
        [contractId, dispatch, uerUpdateContractSubObjectRequest],
    );

    useEffect(() => {
        uerUpdateContractSubObjectReset(undefined);
    }, [uerUpdateContractSubObjectReset]);

    return {
        uerUpdateContractSubObjectData,
        uerUpdateContractSubObjectStatus,
        uerUpdateContractSubObjectError,
        uerUpdateContractSubObjectMakeRequest,
    };
};
